// purely presentational decarb footer bar component
// wrap inside of DecarbFooterBar (which handles logic)

import { FooterAppBar } from '@/components/HeaderAppBar';
import { Button, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';

type FooterProps = {
  backText?: string;
  backIsDisabled?: boolean;
  onBackClick: () => void;

  nextText?: string;
  nextIsDisabled?: boolean;
  nextIsDisabledText?: string;
  onNextClick: () => void;

  onReturnToHubClick: () => void;
  returnText: string;
};

export const BaseDecarbFooterBar: React.FC<FooterProps> = ({
  backText,
  backIsDisabled,
  onBackClick,
  nextText,
  nextIsDisabled,
  nextIsDisabledText,
  onNextClick,
  onReturnToHubClick,
  returnText,
}) => {
  return (
    <FooterAppBar
      position={'sticky'}
      sx={{
        bottom: 0,
        top: 'auto',
        height: 50,
      }}
    >
      <Box
        sx={{ display: 'grid', gridTemplateColumns: '.3fr .3fr .3fr' }}
        justifyContent={'space-between'}
        alignItems={'center'}
        width={'100%'}
        height={'100%'}
        px={10}
      >
        {/** back button */}
        <Button
          variant={'text'}
          color={'info'}
          disabled={backIsDisabled}
          onClick={onBackClick}
          sx={{ justifySelf: 'flex-start' }}
        >
          <Typography variant={'subtitle2'} color={'text.tertiary'}>
            {backText ? backText : 'BACK'}
          </Typography>
        </Button>
        {/** save and return to hub button */}
        <Button variant={'text'} color={'secondary'} onClick={onReturnToHubClick}>
          <Typography variant={'subtitle2'} color={'text.tertiary'} >
            {returnText}
          </Typography>
        </Button>

        {/** next button */}
        <Stack
          direction={'row'}
          alignItems={'center'}
          spacing={4}
          sx={{ justifySelf: 'flex-end' }}
        >
          {nextIsDisabled && nextIsDisabledText && (
            <Typography variant={'subtitle2'}>{nextIsDisabledText}</Typography>
          )}
          <Button
            variant={'contained'}
            color={'secondary'}
            disabled={nextIsDisabled}
            onClick={onNextClick}
            sx={{ px: 12 }}
          >
            {nextText ? nextText : 'NEXT'}
          </Button>
        </Stack>
      </Box>
    </FooterAppBar>
  );
};
